import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import UserIcon from '@BUP/assets/Icons/user_icon.svg'
import PageLayout from '@BUP/components/Layout/Page'
import TitleDashboard from '@BUP/components/Generics/TitleDashboard'
import { CurrentSociogramContextProvider } from '@BUP/contexts/CurrentSociogramContext'
import { useParams } from 'react-router-dom'
import SurveyData from './survey-data'

const SociogramPageById = () => {
  const [t] = useTranslation()
  const { pageId } = useParams()
  const page = useMemo(() => parseInt(pageId, 10), [pageId])

  return (
    <PageLayout>
      <>
        <TitleDashboard
          icon={UserIcon}
          text={t('pages.data.answerSociogram.title')}
        />
        <CurrentSociogramContextProvider>
          <SurveyData page={page} key={pageId} />
        </CurrentSociogramContextProvider>
      </>
    </PageLayout>
  )
}

export default SociogramPageById
